<template>
    <Dialog
        v-model:visible="dialogVisible"
        modal
        header="Naujas kontaktas"
        :style="{ width: '800px' }"
    >
        <div class="grid grid-cols-2 gap-3 mt-1">
            <FloatLabel v-for="(field, index) in fields" :key="index" variant="on">
                <template v-if="field.type == 'text'">
                    <InputText id="over_label" v-model="contactForm[field.name]" class="w-full" size="small" />
                    <label for="over_label" class="!font-normal">{{ field.label }}</label>
                </template>
                <template v-if="field.type == 'select'">
                    <Select
                        v-model="contactForm[field.name]"
                        :options="field.options"
                        optionLabel="name"
                        class="w-full"
                        size="small"
                    />
                    <label for="over_label" class="!font-normal">{{ field.label }}</label>
                </template>
                <template v-if="field.type == 'date'">
                    <DatePicker
                        v-model="contactForm[field.name]"
                        class="w-full"
                        dateFormat="yy-mm-dd"
                        showIcon
                        size="small"
                    />
                    <label for="over_label" class="!font-normal">{{ field.label }}</label>
                </template>
            </FloatLabel>
        </div>

        <div class="mt-3 flex flex-col justify-end">
            <Button
                label="Sukurti"
                @click="createContact"
                :loading="contactCreating"
                class="self-end"
            />
        </div>
    </Dialog>
</template>

<script setup lang="ts">
// System imports
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { apiRequest } from '@/services/axios.ts'
import { is } from '@/extensions/permissions.ts'
import { Auth } from '@/stores/auth'

// PrimeVue components imports
import Dialog from 'primevue/dialog'
import FloatLabel from 'primevue/floatlabel'
import Select from 'primevue/select'
import InputText from 'primevue/inputtext'
import DatePicker from 'primevue/datepicker'
import Button from '@/components/buttons/Button.vue'

// Refs and variables
let auth = Auth()
const router = useRouter()
const fields = ref()
const contactForm = ref<any>({
    firstname: null,
    lastname: null,
    budget: null,
    email: null,
    phone: null,
    region: null,
    city: null,
    type: null,
    source: null,
    contact_date: null
})
const contactCreating = ref<boolean>(false)

// Emits
const emit = defineEmits(['update:showDialog'])

// Props
let props = defineProps<{
    showDialog: any
}>()

// Hooks
onMounted(() => {
    if (auth.isAuthenticated) {
        loadFields()
    }
})

// Computed
const dialogVisible = computed({
    get: () => props.showDialog,
    set: (val: boolean) => emit('update:showDialog', val)
})

// Methods
async function createContact() {
    // Format the contact_date if it's a Date object
    let formattedDate = null
    if (contactForm.value.contact_date) {
        const date = new Date(contactForm.value.contact_date)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        formattedDate = `${year}-${month}-${day}`
    }

    const formData = {
        ...contactForm.value,
        contact_date: formattedDate
    }

    let response = await apiRequest('post', '/contacts', formData)

    emit('update:showDialog', false)

    contactForm.value = {
        firstname: null,
        lastname: null,
        budget: null,
        email: null,
        phone: null,
        region: null,
        city: null,
        type: null,
        source: null,
        contact_date: null
    }

    router.push({ name: 'contact', params: { id: response.data.data.id } })
}

async function loadFields() {
    let response = await apiRequest('get', '/contacts/new-contact-fields')

    fields.value = response.data.data.fields
}
</script>